var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bid-left-top" }, [
    _c("div", { staticClass: "bid-title" }, [
      _vm._v("Countdown of participating bidding："),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "spaceCenter" }, [
      _c("div", { staticClass: "bid-time-min spaceCenter" }, [
        _c("div", { staticClass: "bid-time-text" }, [
          _c("div", { staticClass: "bid-time-text-big" }, [
            _vm._v(_vm._s(_vm.PrefixInteger(_vm.mm))),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "bid-time-text-sm" }, [_vm._v("MIN")]),
        ]),
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "bid-time-spot" }, [_vm._v(" ")]),
      _vm._v(" "),
      _c("div", { staticClass: "bid-time-sec spaceCenter" }, [
        _c("div", { staticClass: "bid-time-text" }, [
          _c("div", { staticClass: "bid-time-text-big" }, [
            _vm._v(_vm._s(_vm.PrefixInteger(_vm.ss))),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "bid-time-text-sm" }, [_vm._v("SEC")]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }